import type { PhoneAccountTypeValue } from '../schemas/apis/interface';

export function normalizePhoneAccountType(
  value?: string | null
): PhoneAccountTypeValue | null {
  if (value == null) return null;
  const v = String(value).trim().toLowerCase();
  if (v === '') return null;
  if (v === 'trial') return 'trial';
  if (v === 'prod' || v === 'production') return 'prod';
  return null;
}
